// Keep this barrel limited to exports from Icon.tsx. Component icons should be
// imported directly from their files so they do not enter initial bundles.
export { Icon, StatusIcon } from "./Icon";
export type { StatusIconProps } from "./Icon";
